import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Reordering from './components/Reordering';
import ProtectedRoute from './components/ProtectedRoute';
import Logout from './pages/Logout';
import Login from './pages/Login';
import Home from './pages/Home'
import PwdReset from './pages/PwdReset';
import Contact from './pages/Contact';
import Request from './pages/Request';
const ControlPanel = lazy(() => import('./pages/ControlPanel'));
const Messages = lazy(() => import('./pages/Messages'));
const Requests = lazy(() => import('./pages/Requests'));
const Conditions = lazy(() => import('./pages/Conditions'));
const Heating = lazy(() => import('./pages/Heating'));
const Planning = lazy(() => import('./pages/Planning'));
const Construction = lazy(() => import('./pages/Construction'));
const Surface = lazy(() => import('./pages/Surface'));
const Locations = lazy(() => import('./pages/Locations'));
const Sectors = lazy(() => import('./pages/Sectors'));
const AdminLand = lazy(() => import('./pages/AdminLand'));
const AdminHouse = lazy(() => import('./pages/AdminHouse'));
const AdminApartments = lazy(() => import('./pages/AdminApartments'));
const AdminSpaces = lazy(() => import('./pages/AdminSpaces'));
import ApartmentDetails from './pages/ApartmentDetails';
import HouseDetails from './pages/HouseDetails';
import SpaceDetails from './pages/SpaceDetails';
import LandDetails from './pages/LandDetails';
import Apartments from './pages/Apartments';
import Garajuri from './pages/Garajuri';

import Houses from './pages/Houses';
import Lands from './pages/Lands';
import Spaces from './pages/Spaces';
import Error from './pages/Error';
import RedirectHandler from './pages/RedirectHandler';
const AdminGarage = lazy(() => import('./pages/AdminGarage'));
import GarageDetail from './pages/GarageDetail';
import Altele from './pages/Altele';
const AdminAltele = lazy(() => import('./pages/AdminAltele'));
import AlteleDetail from './pages/AlteleDetail';
const AiSettings = lazy(() => import('./pages/AiSettings'));
import CategoryRoute from './components/CategoryRoute';
import LegalDoc from './pages/LegalDoc';
import About from './pages/About';
import { LangContext } from './lib/i18n';
import { useParams } from 'react-router-dom';
import { RO_BASE_MAP } from './lib/ru';

// RU routes render the SAME components as RO, with the language context set to 'ru'.
const RuWrap = ({ children }) => <LangContext.Provider value="ru">{children}</LangContext.Provider>;

const RU_PAGE = { apartamente: Apartments, case: Houses, terenuri: Lands, 'spatii-comerciale': Spaces, garajuri: Garajuri, altele: Altele };
const RU_DETAIL = { apartamente: ApartmentDetails, case: HouseDetails, terenuri: LandDetails, 'spatii-comerciale': SpaceDetails, garajuri: GarageDetail, altele: AlteleDetail };
const RU_CITIES = ['ungheni', 'chisinau', 'balti'];

// /ru/{category}/{oras}/{prodazha|arenda|slug} — list or detail per city
const RuCatRoute = () => {
  const { ruBase, loc, param } = useParams();
  const roBase = RO_BASE_MAP[ruBase];
  const Page = RU_PAGE[roBase];
  const Detail = RU_DETAIL[roBase];
  if (!Page || !RU_CITIES.includes(loc)) return <Error />;
  if (param === 'prodazha') return <RuWrap><Page locationSlug={loc} saleType={1} saleTypeInPath /></RuWrap>;
  if (param === 'arenda') return <RuWrap><Page locationSlug={loc} saleType={2} saleTypeInPath /></RuWrap>;
  return <RuWrap><Detail /></RuWrap>;
};

// /ru/{category}/{prodazha|arenda} — whole-country list
const RuCatRouteWhole = () => {
  const { ruBase, param } = useParams();
  const roBase = RO_BASE_MAP[ruBase];
  const Page = RU_PAGE[roBase];
  if (!Page || (param !== 'prodazha' && param !== 'arenda')) return <Error />;
  return <RuWrap><Page locationSlug="" saleType={param === 'arenda' ? 2 : 1} saleTypeInPath /></RuWrap>;
};

export default function AppRoutes() {
  return (
    <Suspense fallback={<div className="w-full flex justify-center items-center py-[100px]"><Reordering /></div>}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path='/resetare-parola/:uid/:token' element={<PwdReset />} />
      <Route path='/contacte' element={<Contact />} />
      <Route path='/cerere' element={<Request />} />
      <Route path='/404' element={<Error />} />
      <Route path='/ru/404' element={<Error />} />
      <Route path="/:category/:city/:type" element={<RedirectHandler />} />

      <Route path='/utilizatori' element={<ProtectedRoute>
        <ControlPanel />
      </ProtectedRoute>} />
      <Route path='/mesaje' element={<ProtectedRoute>
        <Messages />
      </ProtectedRoute>} />
      <Route path='/cereri' element={<ProtectedRoute>
        <Requests />
      </ProtectedRoute>} />
      <Route path='/conditii' element={<ProtectedRoute>
        <Conditions />
      </ProtectedRoute>} />
      <Route path='/incalzire' element={<ProtectedRoute>
        <Heating />
      </ProtectedRoute>} />
      <Route path='/planificare' element={<ProtectedRoute>
        <Planning />
      </ProtectedRoute>} />
      <Route path='/constructie' element={<ProtectedRoute>
        <Construction />
      </ProtectedRoute>} />
      <Route path='/suprafata' element={<ProtectedRoute>
        <Surface />
      </ProtectedRoute>} />
      <Route path='/locatie' element={<ProtectedRoute>
        <Locations />
      </ProtectedRoute>} />
      <Route path='/sectoare' element={<ProtectedRoute>
        <Sectors />
      </ProtectedRoute>} />
      <Route path='/admin/terenuri' element={<ProtectedRoute>
        <AdminLand />
      </ProtectedRoute>} />
      <Route path='/admin/case' element={<ProtectedRoute>
        <AdminHouse />
      </ProtectedRoute>} />
      <Route path='/admin/apartamente' element={<ProtectedRoute>
        <AdminApartments />
      </ProtectedRoute>} />
      <Route path='/admin/spatii-comerciale' element={<ProtectedRoute>
        <AdminSpaces />
      </ProtectedRoute>} />
      <Route path='/admin/garajuri' element={<ProtectedRoute>
        <AdminGarage />
      </ProtectedRoute>} />
      <Route path='/admin/altele' element={<ProtectedRoute>
        <AdminAltele />
      </ProtectedRoute>} />
      <Route path='/setari-ai' element={<ProtectedRoute>
        <AiSettings />
      </ProtectedRoute>} />


      <Route path='/apartamente/:location/:param/chirie' element={<CategoryRoute page={Apartments} detail={ApartmentDetails} base='apartamente' chirieSuffix />} />
      <Route path='/apartamente/:location/chirie' element={<CategoryRoute page={Apartments} detail={ApartmentDetails} base='apartamente' chirieSuffix />} />
      <Route path='/apartamente/:location/:param' element={<CategoryRoute page={Apartments} detail={ApartmentDetails} base='apartamente' />} />
      <Route path='/apartamente/:param' element={<CategoryRoute page={Apartments} detail={ApartmentDetails} base='apartamente' />} />
      <Route path='/apartamente' element={<CategoryRoute page={Apartments} detail={ApartmentDetails} base='apartamente' />} />

      <Route path='/case/:location/:param/chirie' element={<CategoryRoute page={Houses} detail={HouseDetails} base='case' chirieSuffix />} />
      <Route path='/case/:location/chirie' element={<CategoryRoute page={Houses} detail={HouseDetails} base='case' chirieSuffix />} />
      <Route path='/case/:location/:param' element={<CategoryRoute page={Houses} detail={HouseDetails} base='case' />} />
      <Route path='/case/:param' element={<CategoryRoute page={Houses} detail={HouseDetails} base='case' />} />
      <Route path='/case' element={<CategoryRoute page={Houses} detail={HouseDetails} base='case' />} />

      <Route path='/terenuri/:location/:param/chirie' element={<CategoryRoute page={Lands} detail={LandDetails} base='terenuri' chirieSuffix />} />
      <Route path='/terenuri/:location/chirie' element={<CategoryRoute page={Lands} detail={LandDetails} base='terenuri' chirieSuffix />} />
      <Route path='/terenuri/:location/:param' element={<CategoryRoute page={Lands} detail={LandDetails} base='terenuri' />} />
      <Route path='/terenuri/:param' element={<CategoryRoute page={Lands} detail={LandDetails} base='terenuri' />} />
      <Route path='/terenuri' element={<CategoryRoute page={Lands} detail={LandDetails} base='terenuri' />} />

      {/* Russian version — /ru/* renders the SAME components as RO (lang context 'ru') */}
      <Route path='/ru' element={<RuWrap><Home /></RuWrap>} />
      <Route path='/ru/contacte' element={<RuWrap><Contact /></RuWrap>} />
      <Route path='/ru/cerere' element={<RuWrap><Request /></RuWrap>} />
      {/* Legal documents (RO + RU) */}
      <Route path='/politica-de-confidentialitate' element={<LegalDoc doc='privacy' />} />
      <Route path='/termeni-si-conditii' element={<LegalDoc doc='terms' />} />
      <Route path='/politica-cookie' element={<LegalDoc doc='cookies' />} />
      <Route path='/ru/politika-konfidentsialnosti' element={<RuWrap><LegalDoc doc='privacy' /></RuWrap>} />
      <Route path='/ru/usloviya-ispolzovaniya' element={<RuWrap><LegalDoc doc='terms' /></RuWrap>} />
      <Route path='/ru/politika-cookie' element={<RuWrap><LegalDoc doc='cookies' /></RuWrap>} />
      <Route path='/despre-noi' element={<About />} />
      <Route path='/ru/o-nas' element={<RuWrap><About /></RuWrap>} />

      {/* whole country: /ru/{category}/{prodazha|arenda} */}
      <Route path='/ru/:ruBase/:param' element={<RuCatRouteWhole />} />
      {/* city: /ru/{category}/{oras}/{prodazha|arenda|slug} */}
      <Route path='/ru/:ruBase/:loc/:param' element={<RuCatRoute />} />

      <Route path='/spatii-comerciale/:location/:param/chirie' element={<CategoryRoute page={Spaces} detail={SpaceDetails} base='spatii-comerciale' chirieSuffix />} />
      <Route path='/spatii-comerciale/:location/chirie' element={<CategoryRoute page={Spaces} detail={SpaceDetails} base='spatii-comerciale' chirieSuffix />} />
      <Route path='/spatii-comerciale/:location/:param' element={<CategoryRoute page={Spaces} detail={SpaceDetails} base='spatii-comerciale' />} />
      <Route path='/spatii-comerciale/:param' element={<CategoryRoute page={Spaces} detail={SpaceDetails} base='spatii-comerciale' />} />
      <Route path='/spatii-comerciale' element={<CategoryRoute page={Spaces} detail={SpaceDetails} base='spatii-comerciale' />} />

      <Route path='/garajuri/:location/:param/chirie' element={<CategoryRoute page={Garajuri} detail={GarageDetail} base='garajuri' chirieSuffix />} />
      <Route path='/garajuri/:location/chirie' element={<CategoryRoute page={Garajuri} detail={GarageDetail} base='garajuri' chirieSuffix />} />
      <Route path='/garajuri/:location/:param' element={<CategoryRoute page={Garajuri} detail={GarageDetail} base='garajuri' />} />
      <Route path='/garajuri/:param' element={<CategoryRoute page={Garajuri} detail={GarageDetail} base='garajuri' />} />
      <Route path='/garajuri' element={<CategoryRoute page={Garajuri} detail={GarageDetail} base='garajuri' />} />

      <Route path='/altele/:location/:param/chirie' element={<CategoryRoute page={Altele} detail={AlteleDetail} base='altele' chirieSuffix />} />
      <Route path='/altele/:location/chirie' element={<CategoryRoute page={Altele} detail={AlteleDetail} base='altele' chirieSuffix />} />
      <Route path='/altele/:location/:param' element={<CategoryRoute page={Altele} detail={AlteleDetail} base='altele' />} />
      <Route path='/altele/:param' element={<CategoryRoute page={Altele} detail={AlteleDetail} base='altele' />} />
      <Route path='/altele' element={<CategoryRoute page={Altele} detail={AlteleDetail} base='altele' />} />

      <Route path="*" element={<Error />} />
    </Routes>
    </Suspense>
  );
}
